import React from 'react'

import styled from 'styled-components'

import { Breakpoints } from 'src/utilities/Breakpoints'
import { BrandColors } from 'src/utilities/Colors'

import { BrandButton } from './Button'
import { Body2Regular } from '../blocks/Typography'

interface IContentStackProps {
  backgroundColor?: string
}

const DevDocsBarWrapper = styled.div<IContentStackProps>`
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  gap: 2rem;
  flex-direction: column;

  @media (min-width: ${Breakpoints.md}px) {
    flex-direction: row;
    gap: 4rem;
  }
`

const DevDocsBar = ({
  backgroundColor = BrandColors.pigeon300,
  text
}: {
  backgroundColor?: string
  text: string
}) => {
  return (
    <DevDocsBarWrapper backgroundColor={backgroundColor}>
      <Body2Regular>{text}</Body2Regular>
      <BrandButton
        color={BrandColors.black}
        inverted
        label='View Dev Docs'
        role='secondary'
        to='/docs/overview/'
        target='_blank'
        external
      />
    </DevDocsBarWrapper>
  )
}

export default DevDocsBar
